import { BrowserTracing } from '@sentry/tracing'
import { GOOGLE_TAG_MANAGER_CODE, SENTRY_DNS, SENTRY_ENV } from 'app/commons/constants/env.const'
import 'bootstrap/dist/js/bootstrap'

import * as Sentry from '@sentry/react'
import React from 'react'
import 'react-dates/initialize'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'

import App from './App'
import './index.scss'

if (SENTRY_DNS && SENTRY_ENV) {
  Sentry.init({
    dsn: SENTRY_DNS,
    environment: SENTRY_ENV,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}

const tagManagerArgs = {
  gtmId: GOOGLE_TAG_MANAGER_CODE || '',
}

TagManager.initialize(tagManagerArgs)
const rootElement = document.getElementById('root') as HTMLElement
const root = ReactDOM.createRoot(rootElement)
root.render(<App />)
